import styles from './ScoreHeader.module.css';

export interface PlayerInfo {
  nickname: string;
  avatar: string;
  score: number;
}

export interface ScoreHeaderProps {
  player1: PlayerInfo;
  player2: PlayerInfo;
  sameAvatar?: boolean;
}

function getAvatarSrc(name: string): string {
  const file = name.toLowerCase().replace(/\s+/g, '-');
  return `/avatars/${file}.svg`;
}

export function ScoreHeader({ player1, player2, sameAvatar }: ScoreHeaderProps) {
  return (
    <div className={styles.container} aria-label="Score display">
      <div className={styles.player}>
        <img
          src={getAvatarSrc(player1.avatar)}
          alt={`${player1.nickname}'s avatar`}
          className={styles.avatar}
        />
        <span className={styles.score}>
          {sameAvatar && <span className={styles.label}>P1 </span>}
          {player1.nickname}: {player1.score}
        </span>
      </div>
      <div className={styles.player}>
        <img
          src={getAvatarSrc(player2.avatar)}
          alt={`${player2.nickname}'s avatar`}
          className={styles.avatar}
        />
        <span className={styles.score}>
          {sameAvatar && <span className={styles.label}>P2 </span>}
          {player2.nickname}: {player2.score}
        </span>
      </div>
    </div>
  );
}
